module.exports = __webpack_public_path__ + "img/wrench.9833c586.svg";